// i FUCKING hate shaders, Unity3D ptsd fr
export const vertexShader = `
  precision highp float;
  varying vec2 vUv;
  uniform float uScrollSpeed;
  uniform float uBend;

  void main() {
    vUv = uv;
    vec3 pos = position;

    // bend to follow cylinder surface
    pos.z += sin(uv.x * ${Math.PI.toFixed(8)}) * uBend;

    vec4 modelPos = modelMatrix * vec4(pos, 1.0);
    vec4 viewPos  = viewMatrix * modelPos;

    // lateral warp based on scroll vel
    viewPos.x += pow(modelPos.y, 2.0) * 0.1;
    viewPos.x += sin(uv.y * ${Math.PI.toFixed(8)}) * uScrollSpeed * 2.0;

    gl_Position = projectionMatrix * viewPos;
  }
`;

export const fragmentShader = `
  precision highp float;
  uniform sampler2D uMap;
  uniform float uHover;
  uniform float uShow;
  uniform float uHasImage;
  uniform float uReveal;
  uniform float uDepth;
  uniform float uCardAspect;
  uniform float uImgAspect;
  uniform vec3  uAccent;
  uniform vec3  uColor;
  varying vec2  vUv;

  float roundedRectSDF(vec2 p, vec2 b, float r) {
    vec2 q = abs(p) - b + r;
    return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r;
  }

  void main() {
    // generate correct UV so the image fills the card without stretching
    vec2 uv = vUv;
    if (uImgAspect > uCardAspect) { float s = uCardAspect / uImgAspect; uv.x = (vUv.x - 0.5) * s + 0.5; }
    else                          { float s = uImgAspect / uCardAspect; uv.y = (vUv.y - 0.5) * s + 0.5; }

    vec3 tex = texture2D(uMap, uv).rgb;
    vec3 col = tex;

    // (placeholder only) blend canvas texture over colour gradient
    if (uHasImage < 0.5) {
      float brightness = max(tex.r, max(tex.g, tex.b));
      vec3 grad = mix(uColor * 1.25, uColor * 0.45, clamp(vUv.x * 0.5 + (1.0 - vUv.y) * 0.5, 0.0, 1.0));
      col = mix(grad, tex, smoothstep(0.02, 0.10, brightness));
    }

    float reveal = clamp(uReveal, 0.0, 1.0);
    float cornerR = 0.05 * reveal;
    float sdf = roundedRectSDF(vUv - 0.5, vec2(0.5) - cornerR, cornerR);
    float aa = fwidth(sdf) * 1.2;
    float alpha = 1.0 - smoothstep(-aa, aa, sdf);
    alpha *= smoothstep(0.08, 1.0, reveal);

    // back-facing cards dim just slightly to reinforce depth.
    col *= mix(0.92, 1.0, uDepth);
    col *= mix(1.0, 1.05, uHover);

    gl_FragColor = vec4(col, alpha * uShow);
    #include <colorspace_fragment>
  }
`;